const baseUrl =
  process.env.REACT_APP_ENV === "development" ? "http://localhost:4010" : "";

export default baseUrl;
